export enum EduTradingChartTab {

    Chart = "chart",
    Info = "info",
    Signals = "signals"
}
